export function sendGoogleAnalyticsEvent(action = "", otherOptions = {}) {
    if (window.gtag && typeof window.gtag === "function" && action) {
        window.gtag('event', action, otherOptions);
    }
}